var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("Donut World")]),_c('h4',[_vm._v("The Little Red Barn in Gresham")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }